import http from '@/utils/http';
import httpApi from '@/apis/httpApi';

export const getTableList = ({ current, size }) => {
  return http.post({
    url: httpApi.threeTierMission.tableList,
    data: {
      current,
      size,
    },
  });
};

export const usage = () => {
  return http.post({
    url: httpApi.threeTierMission.usage,
  });
};

export const disableOrenable = ({ taskId, type }) => {
  return http.post({
    url: httpApi.threeTierMission.disableOrenable,
    data: {
      taskId,
      type,
    },
  });
};

export const delTask = ({ taskId }) => {
  return http.post({
    url: httpApi.threeTierMission.delTask,
    data: {
      taskId,
    },
  });
};

export const createTask = (data) => {
  return http.post({
    url: httpApi.threeTierMission.createTask,
    json: data,
  });
};

export const getRuleType = ({ type }) => {
  return http.post({
    url: httpApi.threeTierMission.getRuleType,
    data: {
      type,
    },
  });
};

export const relatedBar = ({ taskId, list }) => {
  return http.post({
    url: httpApi.threeTierMission.relatedBar,
    json: {
      taskId,
      list,
    },
  });
};

export const getClientTableList = ({
  search,
  downloadStatus,
  current,
  size,
  taskId,
  groupId,
}) => {
  return http.post({
    url: httpApi.threeTierMission.getClientTableList,
    data: {
      search,
      downloadStatus,
      current,
      size,
      taskId,
      groupId,
    },
  });
};
export const getServerTableList = ({
  search,
  current,
  size,
  taskId,
  labelName,
  type,
  groupId,
  onlineStatus,
  downloadStatus,
}) => {
  return http.post({
    url: httpApi.threeTierMission.getServerTableList,
    data: {
      search,
      current,
      size,
      taskId,
      labelName,
      type,
      groupId,
      onlineStatus,
      downloadStatus,
    },
  });
};

export const getFileList = ({ current, size }) => {
  return http.post({
    url: httpApi.threeTierMission.getFileList,
    data: {
      current,
      size,
    },
  });
};

export const delFile = ({ fileId }) => {
  return http.post({
    url: httpApi.threeTierMission.delFile,
    data: {
      fileId,
    },
  });
};

export const editRemark = ({ fileId, remark }) => {
  return http.post({
    url: httpApi.threeTierMission.editRemark,
    data: {
      fileId,
      remark,
    },
  });
};

export const getAllFile = () => {
  return http.post({
    url: httpApi.threeTierMission.getAllFile,
  });
};
